import isGuessOrDraftGuessEmpty from 'resources/extensions/isGuessOrDraftGuessEmpty';

export const draftGuessExtensions = {
  // Immutable maps already have an isEmpty method, so this method is named to avoid overwriting that method.
  isDraftGuessEmpty() {
    return isGuessOrDraftGuessEmpty(this);
  }
};
